import createModel from "../../createModel";
import { CodeValueLegacy, AmountLegacy } from "../../common";

export const MutualFundsRegularProfileChange = createModel("MutualFundsRegularProfileChange", (json) => ({
    isChangeAvailable: json.IsChangeAvailable,
    changeFee: AmountLegacy.fromServer(json.ChangeFee),
    disapprovalReason: CodeValueLegacy.fromServer(json.DisapprovalReason),
}));
